export function clientInfoToFormspreeFormat(clientInfo) {
  const data = {
    comments: clientInfo.comments,
    email: clientInfo.emailAddress,
    first_name: clientInfo.firstName,
    floorplans: clientInfo.floorplans,
    is_broker: clientInfo.isBroker,
    last_name: clientInfo.lastName,
    max_budget: clientInfo.maxBudget,
    move_in_date: clientInfo.moveInDate,
    phone: clientInfo.phoneNumber,
    private: clientInfo.private,
    terrace_unit: clientInfo.terraced,
    unitNumber: clientInfo.unitNumber,
    url_params: clientInfo.url_params,
    full_name: clientInfo.firstName + " " + clientInfo.lastName,
    lead_source: clientInfo.lead_source,
  };
  return data;
}



// WEBPACK FOOTER //
// ./client/services/formspreedata.js